import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Box, Chip, Typography } from "@mui/material";

import {
  BlockAccIcon,
  GreyBriefCaseIcon,
  GreyEnvelopeIcon,
  GreyLocationIcon,
  GreyProfileIcon,
  GreyWhatsappIcon,
  UnblockAccIcon
} from "../../../../utils/Icons";
import messages from "../../../../assets/locale/messages";
import {
  getImporterDetailsRequest,
  getImporterDetailsResponse
} from "../../../../store/Users/actions";
import {
  CATEGORY_STATUS_IDS,
  CHIPS_CLASSES
} from "../../../../utils/Constants";
import Button from "../../../../components/Button";
import BlockUnblockImporter from "../../BlockUnblockImporterModal";
import TruncateText from "../../../../components/TruncateText";

const ImporterDetails = () => {
  const lang = useSelector((state) => state.locale.lang);
  const { id } = useParams();
  const dispatch = useDispatch();
  const importerDetails = useSelector(
    (state) => state.users.importerDetails
  );
  const [
    isBlockUnblockImporterModalOpen,
    setIsBlockUnblockImporterModalOpen
  ] = useState(false);
  const [
    blockedUnblockedImporterInfo,
    setBlockedUnblockedImporterInfo
  ] = useState({});

  useEffect(() => {
    if (id) {
      dispatch(getImporterDetailsRequest({ id }));
    }
    return () => {
      dispatch(getImporterDetailsResponse({}));
      setBlockedUnblockedImporterInfo({});
    };
  }, []);

  const {
    users: {
      importersList,
      importersDetails,
      importersDetails: {
        pageTitle,
        blockBtn,
        unblockBtn,
        company: { companyInfo, country, businessType, categories },
        account: {
          accountInfo,
          accountName,
          emailAddress,
          mobileNumber
        },
        pendingCategoryWarning,
        rejectedCategoryWarning
      }
    }
  } = messages[lang];

  const [truncateLength, setTruncateLength] = useState(0);
  const handleResize = () => {
    const width = window.innerWidth;
    if (width >= 1440) {
      setTruncateLength(35);
    } else if (width >= 1024) {
      setTruncateLength(19);
    } else if (width >= 768) {
      setTruncateLength(19);
    } else if (width >= 425) {
      setTruncateLength(35);
    } else if (width >= 375) {
      setTruncateLength(28);
    } else {
      setTruncateLength(22);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const renderLabelValue = (label, value, icon, customStyle) => (
    <div className="d-flex align-items-center text-break">
      <div>{icon}</div>
      <div className="mx-3">
        <p className="text-light-grey mb-1 fsize-12">{label}</p>
        <div
          className={`text-color fsize-15 fweight-500 mb-0 ${customStyle}`}>
          <TruncateText text={value} length={truncateLength} />
        </div>
      </div>
    </div>
  );

  const handleChipClass = (categoryStatusId) => {
    let chipClass;
    switch (categoryStatusId) {
      case CATEGORY_STATUS_IDS.approved: {
        chipClass = "blue-chip";
        break;
      }
      case CATEGORY_STATUS_IDS.pending: {
        chipClass = "orange-chip";
        break;
      }
      case CATEGORY_STATUS_IDS.rejected: {
        chipClass = "red-chip";
        break;
      }
      default:
        chipClass = "";
    }
    return chipClass;
  };

  const handleOpenBlockUnblockModal = (isBlockModal) => {
    setIsBlockUnblockImporterModalOpen(true);
    setBlockedUnblockedImporterInfo({
      id,
      name: importerDetails.CompanyName,
      isBlockModal
    });
  };

  const handleClose = () => {
    setIsBlockUnblockImporterModalOpen(false);
  };

  const handleImporterStatusChip = (isActive, isBlocked) => {
    return isBlocked
      ? CHIPS_CLASSES.red
      : isActive
        ? CHIPS_CLASSES.green
        : CHIPS_CLASSES.red;
  };

  return (
    <div className="importer-details-container">
      <div className="page-title title-color mb-4">
        <div className="title-disable-container d-flex justify-content-between align-items-center">
          <div className="title-container">
            <Typography variant="h5">{pageTitle}</Typography>
          </div>
          {importerDetails &&
            !!Object.keys(importerDetails).length && (
              <div className="block-btn-container">
                {!importerDetails.IsBlocked ? (
                  <Button
                    label={
                      <span className="d-flex align-items-center w-auto">
                        <BlockAccIcon className="me-0 me-md-2" />
                        <span className="fsize-16 fweight-500 d-none d-md-block">
                          {blockBtn}
                        </span>
                      </span>
                    }
                    outlined
                    reversedcolor
                    danger
                    className="pe-2 ps-2 pe-md-4 ps-md-4"
                    onClick={() => {
                      handleOpenBlockUnblockModal(true);
                    }}
                  />
                ) : (
                  <Button
                    label={
                      <span className="d-flex align-items-center w-auto text-white">
                        <UnblockAccIcon className="me-0 me-md-2" />
                        <span className="fsize-16 fweight-500 d-none d-md-block">
                          {unblockBtn}
                        </span>
                      </span>
                    }
                    className="pe-2 ps-2 pe-md-4 ps-md-4"
                    onClick={() => {
                      handleOpenBlockUnblockModal(false);
                    }}
                  />
                )}
              </div>
            )}
        </div>
      </div>
      {importerDetails && !!Object.keys(importerDetails).length && (
        <div className="importer-data-container bg-white border-radius-10 p-md-4 p-3 col-12">
          <div className="company-data-container mb-4 pb-4 light-border-bottom">
            <div className="mb-4 block-title title-color d-flex mb-4 flex-column flex-md-row align-items-start align-items-md-center">
              <Typography
                variant="h6"
                className="fweight-700 title-color fsize-24 pe-3">
                {importerDetails.CompanyName}
              </Typography>
              <Box
                sx={{
                  width: "2px",
                  height: "35px",
                  backgroundColor: "divider",
                  display: {
                    xs: "none",
                    sm: "block",
                    md: "block"
                  }
                }}
              />
              <Chip
                label={
                  importerDetails.IsBlocked
                    ? importersDetails.blocked
                    : importerDetails.IsActive
                      ? importersList.active
                      : importersList.inactive
                }
                className={`border-radius-5 fsize-14 fweight-400 my-2 ms-md-3 ms-0  ${handleImporterStatusChip(importerDetails.IsActive, importerDetails.IsBlocked)}`}
              />
            </div>
            <div className="company-info-section mb-md-0 mb-3">
              <h4 className="fsize-16 fweight-600 title-color mb-3">
                {companyInfo}
              </h4>
              <div className="d-md-flex align-items-md-center">
                <div className="col-md-6 col-12 mb-4">
                  {renderLabelValue(
                    country,
                    importerDetails.Country || "--",
                    <GreyLocationIcon dimensions={"24"} />
                  )}
                </div>
                <div className="col-md-6 col-12 mb-4">
                  {renderLabelValue(
                    businessType,
                    importerDetails.BusinessType || "--",
                    <GreyBriefCaseIcon dimensions={"24"} />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="categories-section mb-4 mb-md-0">
            <h4 className="fsize-16 fweight-600 title-color mb-3">
              {categories}
            </h4>
            {importerDetails?.Categories &&
              !!importerDetails.Categories.length &&
              importerDetails?.Categories?.some(
                (category) =>
                  category.Status === CATEGORY_STATUS_IDS.pending
              ) && (
                <Typography className="text-secondary fsize-13 ps-md-1 pt-2 text-break mb-1">
                  {pendingCategoryWarning}
                </Typography>
              )}
            {importerDetails?.Categories &&
              !!importerDetails.Categories.length &&
              importerDetails?.Categories?.some(
                (category) =>
                  category.Status === CATEGORY_STATUS_IDS.rejected
              ) && (
                <Typography className="text-secondary fsize-13 ps-md-1 pt-2 text-break mb-1">
                  {rejectedCategoryWarning}
                </Typography>
              )}
            <div className="categories-chips d-flex justify-content-start flex-wrap">
              {importerDetails?.Categories &&
              !!importerDetails.Categories.length
                ? importerDetails?.Categories.map(
                    ({ Name, Id, Status }, i) => (
                      <Chip
                        key={`category-${Id}`}
                        label={Name}
                        className={`border-radius-5 fsize-14 fweight-400 ${i === 0 ? "" : "mx-2"}  my-2  ${handleChipClass(Status)}`}
                      />
                    )
                  )
                : null}
            </div>
          </div>
          <div className="exporter-data-container my-4">
            <h4 className="fsize-16 fweight-600 title-color mb-3">
              {accountInfo}
            </h4>
            <div className="d-md-flex">
              <div className="col-md-4 col-12 my-md-0 mb-4">
                {renderLabelValue(
                  accountName,
                  importerDetails.FullName || "--",
                  <GreyProfileIcon dimensions={"24"} />
                )}
              </div>
              <div className="col-md-4 col-12 my-md-0 my-4">
                {renderLabelValue(
                  emailAddress,
                  importerDetails.Email || "--",
                  <GreyEnvelopeIcon dimensions={"24"} />
                )}
              </div>
              <div className="col-md-4 col-12 my-md-0 mt-4">
                {renderLabelValue(
                  mobileNumber,
                  importerDetails.MobileNumber || "--",
                  <GreyWhatsappIcon dimensions={"24"} />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <BlockUnblockImporter
        open={isBlockUnblockImporterModalOpen}
        closeModal={handleClose}
        importerInfo={blockedUnblockedImporterInfo}
      />
    </div>
  );
};

export default ImporterDetails;
